//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { useDropzone } from "react-dropzone";
import FilesIcon from "@material-ui/icons/FileCopy";
import UploadButton from "src/components/loader/buttons/UploadButton";
import ConfigurationCheckBox from "eai-configurator-ui/components/configuration/base/ConfigurationCheckBox";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  button: {
    margin: 4,
  },
  dropzone: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  },
}));
const UploadPage = ({ disabled, navigateToResults, dropzoneOptions }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const {
    getRootProps,
    getInputProps,
    open: handleOpenFileSelection,
  } = useDropzone({
    // accept: 'image/jpeg, image/png'
    onDrop: (files) => setSelectedFiles(files),
    ...dropzoneOptions,
  });

  const enableDeletesPath = "loader:upload:enableDeletes";
  React.useEffect(() => {
    // Reset deletes to false when navigating away from the page (this option has to be enabled explicitly each time)
    return () => {
      Config.setDataValue(enableDeletesPath, false);
    };
  }, []);

  const clearSelectedFiles = () => {
    setSelectedFiles([]);
  };

  const selectedFilesItems = selectedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  const classes = useStyles();
  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>Upload from Excel</h5>
          <hr />
        </Typography>

        <React.Fragment>
          <div {...getRootProps({ className: classes.dropzone })}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          <aside>
            <ul>{selectedFilesItems}</ul>
          </aside>
          <Box display="flex" flexDirection="row" justifyContent="flex-end">
            <div>
              <ConfigurationCheckBox path={enableDeletesPath} />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                startIcon={<FilesIcon />}
                onClick={handleOpenFileSelection}
              >
                Choose File(s)
              </Button>
              <UploadButton
                className={classes.button}
                selectedFiles={selectedFiles}
                clearSelectedFiles={clearSelectedFiles}
                disabled={selectedFilesItems.length === 0 || disabled}
                handleSuccess={navigateToResults}
              />
            </div>
          </Box>
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};
export default UploadPage;
